import createReactSolidComponent from '../createReactSolidComponent';
export default createReactSolidComponent('codesandbox', 'CodesandboxSolid', [["path",{"d":"M5.25 5.25h13.5v13.5H5.25zm1.5 1.5v10.5h10.5V6.75z","key":"svg-0"}]]);